import React, { useEffect } from "react";
import { Avatar, Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { TargetOrderStyles } from "../styles/TargetOrder.style";
import api from "src/store/features/api";
import { useAppDispatch } from "src/store/store";
import { resetForm, setCtSuccess, toggleSummeryView } from "src/store/features/TargetOrders.slice";
import { trackEvent } from "src/Amplitude";

const TargetOrderSuccessScreen = () => {
  // ---------------- REDUX----------------------
  const { data: user } = api.useGetUserDatav2Query();
  const appDispatch = useAppDispatch();
  // ---------------- STYLES----------------------
  const classes = TargetOrderStyles();
  const theme = useTheme();
  // ---------------- CONST----------------------
  const BROKER_EMAIL = user?.broker.email;
  const BROKER_NAME = user?.broker.name;
  const BROKER_IMG = user?.broker.imgUrl;
  const USER_NAME = user?.details.name;

  useEffect(() => {
    appDispatch(setCtSuccess(true));

    return () => {
      appDispatch(setCtSuccess(false));
    };
  }, []);

  return (
    <Grid container sx={{ padding: "0px 24px 0px 24px" }} id="target-order-success-screen">
      <Grid
        item
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          justifyContent: "center",
          paddingTop: "32px",
        }}>
        <CheckCircleIcon
          sx={{
            height: "16px",
            width: "16px",
            color: "#0bec9f",
            marginRight: "8px",
          }}
        />
        <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>Target Requested</Typography>
      </Grid>
      <Grid item sx={{ width: "100%" }}>
        <Box
          sx={{
            position: "relative",
            height: "285px",
            borderRadius: "20px",
            padding: " 40px 24px 32px",
            backgroundColor: "#fdf9f1",
            marginTop: "136px",
            width: "100%",
          }}>
          <Avatar
            alt={BROKER_NAME}
            src={BROKER_IMG}
            sx={{
              height: "100px",
              width: "100px",
              position: "absolute",
              top: -80,
              border: 2,
              left: 0,
              right: 0,
              marginLeft: "auto",
              marginRight: "auto",
            }}></Avatar>
          <Typography sx={{ textAlign: "center", paddingBottom: "24px" }}>
            Hi <span>{USER_NAME}</span>!
          </Typography>
          <Stack spacing={2}>
            <Typography className={classes.successText}>
              Congrats, you just placed your target with us.
            </Typography>
            <Typography className={classes.successText}>
              I am currently in the process of entering your target for you.
            </Typography>
            <Typography className={classes.successText}>
              If you need to amend your target, please email me at
              <span style={{ fontWeight: 900 }}>
                <br />
                {BROKER_EMAIL}
              </span>
            </Typography>
          </Stack>
        </Box>
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          paddingTop: "60px",
        }}>
        <Button
          disableRipple
          variant="contained"
          onClick={() => {
            trackEvent("Select_Target_Order_Another_Target_Order");
            appDispatch(toggleSummeryView());
            appDispatch(resetForm());
          }}
          sx={{ backgroundColor: theme.palette.secondary.main }}>
          Add Another Target
        </Button>
      </Grid>
    </Grid>
  );
};

export default TargetOrderSuccessScreen;
